import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { ActiveCallsFilterOptions } from '../../models/active-calls-filter-option';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';

const area = 'Account Call History Register';
export const accountCallHistoryRegisterAdapterActions = createRegisterActions<ActiveCallsRegisterListItem>(area);

export const openDialog = createAction(`[${area}] Open Dialog`, props<{ callLogs: any }>());

export const callHistoryRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: ActiveCallsFilterOptions[] }>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);

export const toggleAutoRefresh = createAction(`[${area}] Toggle Auto Refresh`, props<{ isAutoRefresh: boolean }>());
